var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgWaves = function SvgBgWaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 544,
    height: 520
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-waves_svg__a",
    x1: "45.781%",
    x2: "53.892%",
    y1: "19.324%",
    y2: "80.142%"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-color-start",
    offset: "0%",
    stopColor: "#F1F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-color-end",
    offset: "100%",
    stopColor: "#D7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-waves_svg__d",
    x1: "22.103%",
    x2: "54.117%",
    y1: "6.734%",
    y2: "79.528%"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop-color-start",
    offset: "0%",
    stopColor: "#EBF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop-color-end",
    offset: "100%",
    stopColor: "#DAEDFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-waves_svg__c",
    width: "104.7%",
    height: "101.9%",
    x: "-2.3%",
    y: "-.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.142045455 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-waves_svg__f",
    width: "101.1%",
    height: "101%",
    x: "-.6%",
    y: "-.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.150103802 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bg-waves_svg__b",
    d: "M284.128 81.382c-13.353 14.63-23.837 32.495-26.797 52.096-2.55 16.907.56 34.077 1.738 51.132 1.174 17.058.068 35.307-9.65 49.359-11.819 17.096-33.445 24.084-49.16 37.666-16.849 14.56-23.832 37.211-25.036 59.473-3.631 67.3 38.305 74.198 39.145 115.044.273 13.327-3.7 26.427-7.35 39.247-3.503 12.309-1.406 23.08 8.384 37.601-5.357-8.659-7.925-18.992-6.32-29.137 1.762-11.118 7.729-21.027 12.366-31.28 15.41-34.076 4.985-53.101-14.56-80.266-15.007-20.853-14.389-57.334 6.934-73.587 22.443-17.11 52.544-7.618 77.207-17.738 21.93-9.001 34.936-30.349 37.427-53.406 2.948-27.275-14.478-51.639-8.614-79.014 3.967-18.515 18.219-24.404 30.972-36.095 11.302-10.36 15.511-26.491 16.106-41.83.404-10.37-.683-20.947-4.078-30.705A86 86 0 0 0 350.186 49c-10.746 0-21.452 2.06-31.35 6.422-13.311 5.865-24.892 15.209-34.708 25.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-waves_svg__e",
    d: "M623.846 605.687c-19.302-2.518-40.821-2.12-58.444-11.502-20.652-10.994-22.147-29.122-29.691-49.142-12.967-34.41-50.41-42.814-82.955-33.259-22.52 6.613-45.79 24.82-70.41 18.995-21.358-5.054-37.148-27.69-33.694-49.436 1.764-11.11 7.74-21.011 12.384-31.257 15.438-34.046 4.993-53.055-14.584-80.195-15.03-20.837-14.411-57.285 6.945-73.525 22.483-17.096 52.633-7.612 77.337-17.724 21.969-8.994 34.996-30.323 37.49-53.363 2.952-27.252-14.503-51.593-8.628-78.945 3.974-18.5 18.25-24.383 31.025-36.065 11.319-10.352 15.535-26.47 16.133-41.793.52-13.346-1.386-27.05-7.592-38.877S482.059 8.02 469.009 5.159c-13.292-2.914-27.672-1.533-41.073-3.783-16.686-2.8-255.33-.712-272.098.858-30.834 2.89-61.452 9.775-89.771 22.305-13.662 6.045-32.686-7.435-40.869 5.06C19.795 37.848 4.455 60.371 2.343 70c-5.108 23.282-.32 52.496 0 76.334.235 17.471-.651 33.6 0 50.666 1.856 48.732 12.221 101.89 10.354 150.7a7081 7081 0 0 0-5.143 296.858c.116 31.792-1.492 73.575 29.33 92.374 13.239 8.076 28.774 11.382 44.042 14.103 107.371 19.148 437.982 15.82 545.63-1.697 15.23-2.48 30.77-5.365 44.104-13.126 25.569-14.885 36.91-48.26 29.724-76.309-2.548-9.945-6.77-18.155-12.277-24.927-14.718-18.103-38.616-25.941-64.26-29.29z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1)rotate(6 739.34 -3555.687)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg-waves_svg__b",
    fill: "url(#bg-waves_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg-waves_svg__b",
    fill: "#000",
    filter: "url(#bg-waves_svg__c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 559.507 -70)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg-waves_svg__e",
    fill: "url(#bg-waves_svg__d)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg-waves_svg__e",
    fill: "#000",
    filter: "url(#bg-waves_svg__f)"
  })))));
};
export default SvgBgWaves;